module.exports = __webpack_public_path__ + "media/silver_streak.b0d903e7.webm";